import {
  bool, string, shape, extend, number, client, params
} from '@thd-nucleus/data-sources';
import { SalientPoints } from '@thd-olt-component-react/salient-points';

export const ProductModel = extend({
  itemId: string(),
  dataSources: string(),
  fulfillment: client(params({ storeId: string() }).shape({
    anchorStoreStatus: bool(),
    anchorStoreStatusType: string(),
    backordered: bool(),
    backorderedShipDate: string(),
    bossExcludedShipStates: string(),
    bodfsAssemblyEligible: bool(),
    seasonStatusEligible: bool(),
    excludedShipStates: string(),
    fulfillmentOptions: shape({
      fulfillable: bool(),
      messages: string(),
      services: shape({
        type: string(),
        isDefault: bool(),
        deliveryCharge: string(),
        deliveryDates: shape({
          endDate: string(),
          startDate: string(),
        }),
        deliveryTimeline: string(),
        freeDeliveryThreshold: string(),
        totalCharge: string(),
        locations: shape({
          type: string(),
          isAnchor: bool(),
          locationId: string(),
          storeName: string(),
          storePhone: string(),
          state: string(),
          distance: string(),
          inventory: shape({
            quantity: string(),
            isInStock: bool(),
            isOutOfStock: bool(),
            isLimitedQuantity: bool(),
            isUnavailable: bool(),
            maxAllowedBopisQty: string(),
            minAllowedBopisQty: string(),
          }),
        })
      }),
      type: string()
    }),
    inStoreAssemblyEligible: bool(),
    onlineStoreStatus: bool(),
    onlineStoreStatusType: string(),
  })),
  info: shape({
    quantityLimit: number()
  })
}, SalientPoints.dataModel.product);
